import React, { useEffect, useRef, useState } from 'react';
import { PropTypes } from 'prop-types';
import { FormInputIcon, FormInputItem } from 'blaze-form';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import Pikaday from '../../report/vendor/pikaday/pikaday-dsi';

const FormInputCalendarItem = props => {
  const { field, value, onChange, onBlur, ...rest } = props;
  const { inputProps = {} } = field;
  const [date, setDate] = useState(value);

  const showToday = !!inputProps.showToday;
  const showYesterday = !!inputProps.showYesterday;

  const inputField = useRef(null);
  const iconRef = useRef(null);
  let pikaObject;

  const handleBlur = () => {
    const result = onBlur(field.name);

    // Make sure the date picker is closed on a blur
    if (result && pikaObject) {
      pikaObject.hide();
    }

    return result;
  };

  const handleChange = (name, newDate) => {
    onChange(name, newDate);
    setDate(newDate);
  };

  const handleSelect = (name, newDate) => {
    onChange(name, newDate);
    setDate(newDate);
    onBlur(name);
  };

  useEffect(() => {
    if (!field.readOnly) {
      const triggerHide = event => {
        if (event.keyCode === 27) {
          if (pikaObject) {
            pikaObject.hide();
          }
          document.removeEventListener('keyup', triggerHide);
        }
      };

      const onSelect = () => {
        handleSelect(field.name, pikaObject.toString());
      };

      if (inputField.current && iconRef.current) {
        pikaObject = new Pikaday({
          field: inputField.current,
          format: 'MM-DD-YYYY',
          trigger: iconRef.current,
          onSelect,
          onOpen: () => document.addEventListener('keyup', triggerHide),
          onClose: () => document.removeEventListener('keyup', triggerHide),
        });
      }
    }

    return () => {
      if (pikaObject) {
        pikaObject.destroy();
      }
    };
  }, []);

  const today = moment().format('MM-DD-YYYY');
  const yesterday = moment().subtract(1, 'day').format('MM-DD-YYYY');

  const containerClass = {
    'has-icon': true,
  };

  return (
    <FormInputItem
      containerClass={containerClass}
      onBlur={handleBlur}
      onChange={handleChange}
      ref={inputField}
      value={date}
      field={field}
      alwaysUpdate
      {...rest}
    >
      <FormInputIcon icon="calendar" ref={iconRef} />{' '}
      <div className="input-toolbar-wrapper">
        <div className="input-toolbar">
          {showToday && (
            <>
              <Button
                style={{ fontSize: '10px' }}
                variant={today === date ? 'primary' : 'default'}
                disabled={today === date}
                size="xs"
                onClick={() => setDate(today)}
              >
                Today
              </Button>{' '}
            </>
          )}

          {showYesterday && (
            <Button
              style={{ fontSize: '10px' }}
              variant={yesterday === date ? 'primary' : 'default'}
              disabled={yesterday === date}
              size="xs"
              onClick={() => setDate(yesterday)}
            >
              Yesterday
            </Button>
          )}
        </div>
      </div>
    </FormInputItem>
  );
};

FormInputCalendarItem.defaultProps = {
  field: {},
  onBlur: () => {},
  onChange: () => {},
  value: '',
};

FormInputCalendarItem.propTypes = {
  field: PropTypes.object,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default FormInputCalendarItem;
